export default Object.freeze({
  DriveUploadFile: 1,
  DriveDownloadFile: 2,
});
